import React, { memo } from "react";
import { Box, Container, Grid2, Stack, Typography } from "@mui/material";
import { HOME_HISTORY_STEPS } from "../../../../Configurations/SiteCopy";

// Lock It 5 — "Home History" steps: We find / You build / Stays with the home.
// Illustrations live in /public (step1.png, step2.png, step3.png).
const GREEN = "#0f4b39";
const SERIF = '"PT Serif", Georgia, "Times New Roman", serif';

const HomeHistorySteps = memo(() => {
  return (
    <Box component="section" sx={{ backgroundColor: "#f6f7f5", py: { xs: 6, md: 10 }, mt: { xs: 8, md: 12 } }}>
      <Container maxWidth="xl">
        <Grid2 container spacing={0} alignItems="flex-start">
          {HOME_HISTORY_STEPS.STEPS.map((s, i) => (
            <Grid2
              key={s.num}
              size={{ xs: 12, md: 4 }}
              sx={{
                px: { xs: 0, md: 4 },
                mb: { xs: 5, md: 0 },
                borderLeft: { xs: "none", md: i === 0 ? "none" : "1px solid #dfe4e0" },
              }}
            >
              <Box sx={{ display: "flex", justifyContent: "center", minHeight: { xs: 210, md: 240 }, mb: 1 }}>
                <Box
                  component="img"
                  src={s.img}
                  alt={s.title}
                  loading="lazy"
                  sx={{ width: "100%", maxWidth: 300, height: "auto", display: "block" }}
                />
              </Box>
              <Stack spacing={1.5} alignItems="flex-start">
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: 42,
                    height: 42,
                    borderRadius: "50%",
                    backgroundColor: GREEN,
                    color: "#fff",
                    fontFamily: SERIF,
                    fontWeight: 700,
                    fontSize: "18px",
                  }}
                >
                  {s.num}
                </Box>
                <Typography
                  sx={{
                    fontFamily: SERIF,
                    fontWeight: 700,
                    color: GREEN,
                    fontSize: { xs: "22px", md: "26px" },
                    lineHeight: 1.1,
                  }}
                >
                  {s.title}
                </Typography>
                <Typography sx={{ color: "#6c766f", fontSize: "16px", lineHeight: 1.5, maxWidth: "28ch" }}>
                  {s.body}
                </Typography>
              </Stack>
            </Grid2>
          ))}
        </Grid2>
      </Container>
    </Box>
  );
});

HomeHistorySteps.displayName = "HomeHistorySteps";

export default HomeHistorySteps;
